/* Shared between `List.js` and `OrderDetail.js` so the two screens can't drift apart on how a
   status renders — same icon, same tone, wherever an order's status is shown. */

import { CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined, SyncOutlined, TruckOutlined } from "@ant-design/icons";

/* tone is the shared ok/no/wait/off contract (`table-cells.js`); "sent_for_delivering" is still
   in flight, not a final state, so it reads `wait` like `new`/`processing`. */
export const STATUS_ICON = {
  new: { Icon: ClockCircleOutlined, tone: "wait" },
  processing: { Icon: SyncOutlined, tone: "wait" },
  sent_for_delivering: { Icon: TruckOutlined, tone: "wait" },
  closed: { Icon: CheckCircleOutlined, tone: "ok" },
  canceled: { Icon: CloseCircleOutlined, tone: "no" },
};
